import axios from 'axios';
import apiBaseUrl from '@/config/api-base-url';

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': 'def8e0041c8f4cc0918773d15b474a77'
  },
  transformRequest: [
    data => {
      return JSON.stringify(data);
    },
  ],
  transformResponse: [
    data => {
      return JSON.parse(data);
    },
  ],
});

export default apiClient;
